<div class="modal is-active">
    <div id="modal-waiting">
        <!--<mat-spinner color="primary"></mat-spinner> -->
        <img src="assets/img/logo-brasao.png" class="animated-logo">
        <h4>{{message}}</h4>
    </div>
</div>
